var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ToolbarWithBackButton } from '../common/Toolbar';
import { Body } from '../root/PageRouter';
import { Grid, Tile, TileHeader, TileComment } from '../common/Tile';
import { getEmail } from './helpers';
import Loading from '../common/Loading';
import { startCase, snakeCase } from 'lodash/fp';
import { useRouter } from '../../context/router-context';
import { List, ListItem } from '@bootstraplabs/bsw-common-react';
import { useAddRoleMutation, useRemoveRoleMutation, useAdminUserDetailsQuery, UserRole, } from '../../__generated__/graphql';
function Toolbar() {
    return _jsx(ToolbarWithBackButton, { children: "Manage User Roles" }, void 0);
}
export default function AdminUserDetails() {
    // Router
    var match = useRouter().match;
    var id = match.params.userId;
    // GraphQL query
    var _a = useAdminUserDetailsQuery({ variables: { id: id } }), data = _a.data, loading = _a.loading;
    var user = data && data.user;
    var addRoleMutation = useAddRoleMutation()[0];
    var removeRoleMutation = useRemoveRoleMutation()[0];
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(Toolbar, {}, void 0),
                _jsx(Loading, {}, void 0)] }, void 0));
    }
    if (!user) {
        throw new Error('User query failed, user not found');
    }
    var availableRoles = Object.keys(UserRole).filter(function (e) { return !user.roles.includes(e); });
    function handleRemoveRoleClick(role) {
        var _this = this;
        return function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, removeRoleMutation({
                            variables: {
                                input: {
                                    role: role,
                                    userId: id,
                                },
                            },
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    }
    function handleAddRoleClick(role) {
        var _this = this;
        return function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, addRoleMutation({
                            variables: {
                                input: {
                                    role: role,
                                    userId: id,
                                },
                            },
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    }
    return (_jsxs(_Fragment, { children: [_jsx(Toolbar, {}, void 0),
            _jsx(Body, { children: _jsx(Grid, { children: _jsxs(Tile, __assign({ span: 12 }, { children: [_jsx(TileHeader, { children: getEmail(user) }, void 0),
                            _jsx(TileComment, { children: "Click to add or remove roles." }, void 0),
                            _jsx(TileHeader, { children: "Current Roles" }, void 0),
                            _jsx(List, { children: user.roles.map(function (role) { return (_jsx(ListItem, { primary: startCase(snakeCase(role)), onClick: handleRemoveRoleClick(role) }, role)); }) }, void 0),
                            _jsx(TileHeader, { children: "Available Roles" }, void 0),
                            _jsx(List, { children: availableRoles.map(function (role) { return (_jsx(ListItem, { primary: startCase(snakeCase(role)), onClick: handleAddRoleClick(role) }, role)); }) }, void 0)] }), void 0) }, void 0) }, void 0)] }, void 0));
}
//# sourceMappingURL=AdminUserDetails.js.map